import styled from 'styled-components';
import type { CSSProperties } from 'react';
import dealPulseBadge from '../../dealPulse/Badge.svg';

export const DealPulseCardStyle = styled.div`
    border: 1px solid #b2b2b2;
    border-radius: 6px;
    padding-left: 10px;
    background-color: #ffffff;
    font-size: 13px;
    margin-left: 0px !important;
    @media (max-width: 992px) {
        margin-top: 0px !important;
        padding-left: 0px !important;
    }
`;

export const getTopLevelLabelStyles = (): CSSProperties => {
    return {
        display: 'inline-flex',
        alignItems: 'center',
        '::after': {
            content: '""',
            display: 'inline-block',
            width: '20px',
            height: '20px',
            marginLeft: '8px',
            backgroundImage: `url(${dealPulseBadge})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain'
        }
    } as CSSProperties;
};
